import { SoldToAddress } from "@dana/Types/ApiModels";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const apiBreadthRebateProgram = "/api/v2/Dana/breadthRebateProgram";

export type BreadthRebateProgramAction = "Accept" | "Reject";

export interface PostBreadthRebateProgramApiParameter extends ApiParameter {
    action: BreadthRebateProgramAction;
    soldToId?: string;
}

export interface BreadthRebateProgramResult extends BaseModel {
    isSuccess :string;
    updatedSoldTo: SoldToAddress;
}

export function postBreadthRebateProgram(parameter: PostBreadthRebateProgramApiParameter) {
    return get<BreadthRebateProgramResult>(
        apiBreadthRebateProgram,
        parameter,
    );
}
